import { render, staticRenderFns } from "./MServRedPacketComp.vue?vue&type=template&id=bbeef63c&"
import script from "./MServRedPacketComp.vue?vue&type=script&lang=js&"
export * from "./MServRedPacketComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports